document.addEventListener('DOMContentLoaded', function () {
  // Resume upload events
  var resumeFileUploads = document.querySelectorAll('.resume-file-upload');
  resumeFileUploads.forEach(function (upload) {
    upload.addEventListener('change', function (e) {
      var file = e.target.files[0];
      if (file) {
        var fileNameElement = e.target.closest('.resume-upload').querySelector('.file-name');
        if (fileNameElement) {
          fileNameElement.innerHTML = file.name;
        }
      }
    });
  });

  // Delete resume
  var deleteResumeButtons = document.querySelectorAll('.delete-resume');
  deleteResumeButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      var resumeId = button.dataset.resumeId;
      fetch("/resumes/".concat(resumeId), {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      }).then(function (response) {
        return response.json();
      }).then(function () {
        var currentResume = button.closest('.current-resume');
        if (currentResume) {
          currentResume.remove();
        }
      })["catch"](function (error) {
        return console.error('Error deleting resume:', error);
      });
    });
  });

  // Google Maps Autocomplete for city input
  var cityInput = document.getElementById('consultant-city-input');
  if (cityInput && typeof google !== 'undefined' && google.maps) {
    // eslint-disable-next-line no-new
    new google.maps.places.Autocomplete(cityInput, {
      types: ['(cities)']
    });
  }
});